import api from "./api";
import URLS from "../utils/urls.js";

export const notificationMessages = () => {
  return api.get(URLS.BACKEND_API + `/api/notifications`);
};
